import { createContext } from 'react';

import { Auth0ContextProvider } from './Auth0ContextProvider';
import { useAuth0Context } from './useAuth0Context';

export type Auth0ContextType = {
  isAuth0LogoutInProgress: boolean;
  setIsAuth0LogoutInProgress: (isAuth0LogoutInProgress: boolean) => void;
  // True while dead-RT session recovery is running (from
  // clearCredentials through the silent re-auth attempt). The launch nav gate
  // reads this to hold on a blank loader instead of flashing the Welcome /
  // email-login screen behind the iOS re-auth prompt.
  isAuth0RecoveryInProgress: boolean;
  setIsAuth0RecoveryInProgress: (isAuth0RecoveryInProgress: boolean) => void;
};

export const Auth0Context = createContext<Auth0ContextType | undefined>(
  undefined
);

export { Auth0ContextProvider, useAuth0Context };
